import fetch from 'unfetch'
import app from '@/app.js'

export function addVariant (variant, quantity, addToCart, productId) {

  // The add limit is 2 of each product OR the max inventory of the variant they're trying to add, whichevers less
  //const addLimit = Math.min(999 , variant.inventory_quantity);
  const addLimit = variant.inventory_quantity
  /*
  const numAvailable = variant.inventory_policy === 'deny' && variant.inventory_management === 'shopify' ? (
    variant.inventory_quantity
  ) : null // null means they can add as many as they want
  */

  /* Limit to the addLimit type of each VARIANT of product per cart! */
  const numAvailable = variant.inventory_policy === 'deny' && variant.inventory_management === 'shopify' ? (
    null //addLimit //or specific num limit
  ) : null // null means they can add as many as they want

  
  return fetchCart().then(({ items }) => {
    //console.log("items in cart: " + JSON.stringify(items, null, "\t"))
    //console.log("vs product id: " + productId)

    /* compare against variants */
    //const existing = items.filter(item => item.id === variant.id)[0] || {}

    /* compare against PRODUCTS */
    //const existing = items.filter(item => item.product_id === productId)[0] || {}

    /* compare against array of total variants of that product and their quantities */
    const existing = items.filter(item => item.product_id === productId) || {}
    let totalOfProduct = 0;
    existing.forEach(productVariant => {
      totalOfProduct += productVariant.quantity;
    })

    //console.log("existing: " + JSON.stringify(existing, null, "\t"))
    //console.log("totalOfProduct: " + totalOfProduct)

    //const numRequested = (existing.quantity || 0) + parseInt(quantity)
    const numRequested = (totalOfProduct || 0) + parseInt(quantity)

    if (numAvailable !== null && numRequested > numAvailable) {
      const err = `There are only ${numAvailable} of that product available, requested ${numRequested}.`
      //console.log(err)
      //app.emit('error', err)
      //throw new Error(err)

      /* Can't any more to cart when comparing how many are in cart compared to inventory quantity*/
      addToCart.classList.add('i')
      addToCart.innerHTML = 'Too Many!'
      setTimeout(() => {
        addToCart.classList.remove('i')
        addToCart.innerHTML = 'Add To Cart'
      }, 750)

      
      throw new Error(err)
    } else {
      
      return addItemById(variant.id, quantity)
      
    }
    
    
  })
  
}

export function updateAddon (id, quantity) {
  return fetchCart().then(({ items }) => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].variant_id === parseInt(id)) {
        return changeAddon(i + 1, quantity) // shopify cart is a 1-based index
      }
    }
  })
}

export function removeAddon (id) {
  return updateAddon(id, 0)
}

function changeAddon (line, quantity) {
  app.emit('cart:updating')

  return fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ line, quantity })
  }).then(res => res.json()).then(cart => {
    app.hydrate({ cart: cart })
    app.emit('cart:updated', { cart: cart })
    return cart
  })
}

/**
 * Warning: this does not check available products first
 */
export function addItemById (id, quantity) {

  app.emit('cart:updating')
  
  return fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ id, quantity })
  }).then(r => r.json()).then(item => {
    return fetchCart().then(cart => {
      app.hydrate({ cart: cart })
      app.emit('cart:updated')
      
      app.emit('cart:toggle', state => {
        return {
          cartOpen: !state.cartOpen
        }
      })
      
      // app.emit('updated', { item, cart })
      return { item, cart }
    })
  })
  
}

export function fetchCart () {
  return fetch('/cart.js', {
    method: 'GET',
    credentials: 'include'
  }).then(res => res.json())
}
